import * as Yup from 'yup';

// W-0570 — Matricial de Despesas — Períodos
const periodoSchema = Yup.object({
  descricao: Yup.string().max(50, 'Máximo 50 caracteres'),
  data_ini: Yup.date().required('Data Inicial obrigatória').typeError('Data Inicial inválida'),
  data_fim: Yup.date()
    .required('Data Final obrigatória')
    .typeError('Data Final inválida')
    .min(Yup.ref('data_ini'), 'Período inválido'),
  data_limite: Yup.date().nullable().typeError('Data Limite inválida'),
});

export default periodoSchema;
